import { render, staticRenderFns } from "./dishesBanner.vue?vue&type=template&id=77a804f8&scoped=true"
import script from "./dishesBanner.vue?vue&type=script&lang=js"
export * from "./dishesBanner.vue?vue&type=script&lang=js"
import style0 from "./dishesBanner.vue?vue&type=style&index=0&id=77a804f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a804f8",
  null
  
)

export default component.exports